import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

export interface McpCredentials {
  clientId: string
  clientSecret: string
}

export interface McpCredentialsResponse {
  success: boolean
  credentials: McpCredentials | null
  mcpUrl: string
}

// GET /ajax/account_settings/mcp
export const mcpCredentials = async (): Promise<McpCredentialsResponse> => {
  const response = await new Request().get('/ajax/account_settings/mcp')
  return Util.Obj.keysToCamel(response.data) as McpCredentialsResponse
}
